export interface IJurisdiction {
  code: string;
  name: string;
  name_en: string;
  currency: string;
  effective_from: string | null;
  is_default: boolean;
}

export interface ITaxOptions {
  jurisdiction: IJurisdiction | null;
  vat_rates: number[];
  // NOTE: виды ставок НДС страны (standard, preferential, export); пусто - все (этап 1, F5)
  vat_rate_kinds: string[];
  tax_simulation: number[];
  special_regimes: number[];
  // NOTE: первый налоговый вариант проекта - плательщик НДС (этап 1, F6)
  vat_enabled: boolean;
  // NOTE: страну проекта сменили, а хотя бы один вариант не обновлен под нее (этап 1, F8)
  preset_mismatch: boolean;
}

export interface IJurisdictionChange {
  field: string;
  label: string;
  // NOTE: булевы поля блоков (vat_applies) приходят как true/false (этап 1, F4)
  current: number | boolean | null;
  new: number | boolean | null;
}

export interface IJurisdictionBlockDiff {
  block: string;
  changes: IJurisdictionChange[];
}

// NOTE: F9 - switch: режим недоступен в стране, вариант переводится на минимальный;
// restore: страна снова допускает прежний режим, вариант возвращается на него
export type JurisdictionRegimeKind = 'switch' | 'restore';

export interface IJurisdictionRegimeRef {
  tax_simulation: number;
  tax_regime?: number | null;
}

export interface IJurisdictionRegime {
  from: IJurisdictionRegimeRef;
  to: IJurisdictionRegimeRef;
  label: string;
  kind: JurisdictionRegimeKind;
}

export interface IJurisdictionRegimeChange {
  variant_id: number;
  variant_name: string;
  from: IJurisdictionRegimeRef;
  to: IJurisdictionRegimeRef;
  kind: JurisdictionRegimeKind;
}

export interface IJurisdictionVariantDiff {
  id: number;
  variant_name: string;
  blocks: IJurisdictionBlockDiff[];
  // NOTE: F9 - null, если apply режим варианта не меняет
  regime?: IJurisdictionRegime | null;
  changes_count: number;
}

export interface IJurisdictionDiff {
  jurisdiction: IJurisdiction | null;
  variants: IJurisdictionVariantDiff[];
  changes_count: number;
}

// NOTE: данные диалога подтверждения; onlyVariantId - показать и применить только один вариант
// ("Вернуть по юрисдикции" в форме налогов, этап 1, F4)
export interface IJurisdictionDiffPopupData extends IJurisdictionDiff {
  onlyVariantId?: number;
}

export interface IJurisdictionApplyParams {
  variants: 'all' | 'current';
  variant_id?: number;
}

export interface IJurisdictionApplyResult {
  jurisdiction: IJurisdiction | null;
  updated_variants: number[];
  changes_count: number;
  // NOTE: F9 - варианты, у которых apply сменил режим (switch или restore)
  regime_changes?: IJurisdictionRegimeChange[];
}
